export default "__VITE_ASSET__DQRruD08__"